require("core-js/features/promise");
require("core-js/features/array/for-each")

import Vue from "vue"
import Vuex, { StoreOptions, ActionContext } from "vuex"
import { ContractViewModel, IContractViewModel, IProductViewModel, AddressViewModel, IPriceListViewModel, IContactPersonViewModel, ISelectedServiceProductViewModel, IMembershipTypeViewModel, IContractMembershipViewModel, ContractMembershipViewModel } from "../../../Scripts/inpulse/I4UViewModels";
import { CustomerTypeEnum, MoveOutReasonEnum } from "@/Scripts/inpulse/CommonEnums";
import { NewContractEvents } from "./new-contract-vue-events";

Vue.use(Vuex);

declare var $: any;

export interface INewContractState {
    moveOutUser: string;
    validPinFromDb: boolean;

    contract: IContractViewModel;
    selectedProduct: IProductViewModel;
    selectedPriceList: IPriceListViewModel;
    products: IProductViewModel[];

    // If true, refreshing products will clear the selected product IF the selected product is not among the refreshed ones.
    autoClearSelectedProduct: boolean;

    // This tells if the New Contract module & data has been initialized (i.e. client side model has been set by initValues call from the Hub etc).
    newContractInitialized: boolean;

    contractSettings: IContractSettings;
    environmentSettings: IEnvironmentSettings
    preSelectedProductPriceListTarification: boolean;
    preSelectedProductId: number;
    preSelectedPriceListId: number;
    preSelectedMembership: string;
    isAuthenticated: boolean;
    selectedServiceProducts: string[];
    selectedOfferProducts: string[];
    holidays: string[];
    loadingNewPhase: boolean;
    isUserAuthenticated: boolean;
    membershipTypes: IMembershipTypeViewModel[];
    contractMembershipTemp: IContractMembershipViewModel;
    isProcessTypeSelected: boolean;
    selectedConinueWithSameProductId: number;
    selectedConinueWithSamePriceListId: number;
    offerRequest: boolean;
    offerProducts: string[];
    strongContractAuthentication: boolean;
    contractToNewAddressSelection: number;
}

let state: INewContractState = {
    moveOutUser: null,
    validPinFromDb: null,

    contract: new ContractViewModel() as IContractViewModel,
    selectedProduct: null,
    selectedPriceList: null,
    products: [] as IProductViewModel[],
    autoClearSelectedProduct: true,
    newContractInitialized: false,

    contractSettings: null,
    environmentSettings: null,
    preSelectedProductId: null,
    preSelectedPriceListId: null,
    preSelectedMembership: null,
    preSelectedProductPriceListTarification: false,
    isAuthenticated: false,
    selectedServiceProducts: [] as string[],
    selectedOfferProducts: [] as string[],
    holidays: [] as string[],
    loadingNewPhase: false,
    isUserAuthenticated: false,
    membershipTypes: [] as IMembershipTypeViewModel[],
    contractMembershipTemp: new ContractMembershipViewModel() as IContractMembershipViewModel,
    isProcessTypeSelected: false,
    selectedConinueWithSameProductId: 0,
    selectedConinueWithSamePriceListId: 0,
    offerRequest: false,
    offerProducts: [] as string[],
    strongContractAuthentication: false,
    contractToNewAddressSelection: 0
}

export enum PropertyTypeEnum {
    BasicValue,
    MeteringPointValue,
    ContractValue,
    CustomerValue
}

export interface IContractSettings {
    MovingMinDates: number;
    MovingMinDatesCompany: number;
    SupplierChangeMinDates: number;
    SupplierChangeMinDatesCompany: number;
    ClosingMinDates: number;
    InvoicingMethodsInUse: boolean;
    AvailableLanguages: string[];
    AllowMakingNewSalesContractWithStartDateGreaterThan90Days: boolean;
    ListProductsForContractsWithStartDateGreaterThan90Days: string;
    SelectionForAbsoluteTimeperiodForSelectedProducts: string;
    PriimaPlusProductId: number;
    PriimaProductId: number;
    PriimaPlusPriceListId: number;
    ProductChangeMinDates: number;
    ProductChangeMinDatesCompany: number;
}

export interface IEnvironmentSettings {
    DatahubMeteringPointRestApiVersion: number
}
// Experimental!
class PropDesc {
    type: PropertyTypeEnum;
    propertyNames: string[];
    setValue: (contract: IContractViewModel, value: string) => any;

    constructor(type, propertyNames) {
        this.type = type;
        this.propertyNames = propertyNames;
    }

    static basic(setValue: (contract: IContractViewModel, value: string) => any) {
        let d = new PropDesc(PropertyTypeEnum.BasicValue, null);
        d.setValue = setValue;
        return d;
    }
    static mp(setValue: (contract: IContractViewModel, value: string) => any) {
        let d = new PropDesc(PropertyTypeEnum.MeteringPointValue, null);
        d.setValue = setValue;
        return d;
    }
    static contract(setValue: (contract: IContractViewModel, value: string) => any) {
        let d = new PropDesc(PropertyTypeEnum.ContractValue, null);
        d.setValue = setValue;
        return d;
    }
    static customer(setValue: (contract: IContractViewModel, value: string) => any) {
        let d = new PropDesc(PropertyTypeEnum.CustomerValue, null);
        d.setValue = setValue;
        return d;
    }

    public changeValue(obj: any, value: string,) {
        if (this.setValue != null) {
            this.setValue(obj, value);
        }
        else if (this.propertyNames != null) {
            this.propertyNames.forEach(propName => {
                PropDesc.changeValueInternal(obj, propName, value);
            });
        }
    }

    private static changeValueInternal(obj: any, propertyChain: string, value: string) {
        let parts = propertyChain.split(".");
        let propName = parts[0];
        if (parts.length == 1) {
            obj[propName] = value;
        }
        else {
            let newObj = obj[propName];
            let newPropChain = propertyChain.substr(propertyChain.indexOf(".") + 1);
            this.changeValueInternal(newObj, newPropChain, value);
        }
    }
}

let basicValues = {
    // SetValue
    "Brand": PropDesc.basic((contract, value) => contract.Brand = null),
    "PreSelectedProductAndPriceList": PropDesc.basic((contract, value) => contract.PreSelectedProductAndPriceList = null),
    "campaignCode": PropDesc.basic((contract, value) => contract.CampaignCode = value),
    "contractLocation": PropDesc.basic((contract, value) => contract.ContractLocation = parseInt(value)),
    "heatingType": PropDesc.basic((contract, value) => contract.HeatingTypeId = parseInt(value)),
    "housingType": PropDesc.basic((contract, value) => contract.HousingTypeId = parseInt(value)),
    "tarification": PropDesc.basic((contract, value) => contract.TarificationId = parseInt(value)),
    "energy1": PropDesc.basic((contract, value) => contract.Energy1 = parseInt(value)),
    "energy2": PropDesc.basic((contract, value) => contract.Energy2 = parseInt(value)),
    "reading1": PropDesc.basic((contract, value) => contract.Reading1 = parseInt(value)),
    "reading2": PropDesc.basic((contract, value) => contract.Reading2 = parseInt(value)),
    "meteringType": PropDesc.basic((contract, value) => contract.IsAmr = parseInt(value)),
    "valuation": PropDesc.basic((contract, value) => contract.ValuationId = parseInt(value)),
    "area": PropDesc.basic((contract, value) => contract.HouseArea = parseInt(value)),
    "oldFixedPeriodTime": PropDesc.basic((contract, value) => contract.OldFixedPeriodTime = parseInt(value)),
    "customerType": PropDesc.basic((contract, value) => contract.CustomerType = parseInt(value)),
    "permissionToSearchContactData": PropDesc.basic((contract, value) => contract.PermissionToSearchContactData = value != "0"),
    "ExtraServiceOrder": PropDesc.basic((contract, value) => contract.ExtraServiceOrder = parseInt(value)),
}
let meteringPointValues = {
    // SetMeteringPointValue
    "meteringpoint-street-address_Street": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.Street = value),
    "MPCOName": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.COName = value),
    "MPStreet": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.Street = value),
    "MoveOutStreetOnline": PropDesc.mp((contract, value) => contract.MoveOutProcess.FinalInvoicingAddress.Address.Street = value),
    "MoveOutZipOnline": PropDesc.mp((contract, value) => contract.MoveOutProcess.FinalInvoicingAddress.Address.Zip = value),
    "MoveOutCONameOnline": PropDesc.mp((contract, value) => contract.MoveOutProcess.FinalInvoicingAddress.Address.COName = value),
    "MoveOutEmail": PropDesc.mp((contract, value) => contract.MoveOutProcess.FinalInvoicingAddress.Email = value),
    //"meteringpoint-street-address_StreetName": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.StreetName = value),
    //"MPStreetName": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.StreetName = value),
    //"meteringpoint-street-address_StreetQualifier": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.HouseNumber = value),
    //"meteringpoint-street-address_StairCase": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.Staircase = value),
    //"meteringpoint-street-address_Apartment": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.Apartment = value),
    "MPZip": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.Zip = value),
    "meteringpoint-street-address_PostalCode": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.Zip = value),
    "MPCode": PropDesc.mp((contract, value) => contract.MeteringPoint.MeteringPointCode = value),
    "NWCode": PropDesc.mp((contract, value) => contract.MeteringPoint.NetworkCompanyCode = value),
    "NWName": PropDesc.mp((contract, value) => contract.MeteringPoint.NetworkCompanyName = value),
    //"StartDate": PropDesc.mp((contract, value) => contract.StartDate = value),
    "StartDate": PropDesc.mp(null),
    "MovingMPStreet": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.Street = value),
    "MovingMPZip": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.Zip = value),
    "ResetOldMPAddress": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address = new AddressViewModel()),
    "OldMPStreet": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.Street = value),
    "oldmeteringpoint-street-address_Street": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.Street = value),
    //"oldmeteringpoint-street-address_StreetName": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.StreetName = value),
    //"oldmeteringpoint-street-address_StreetQualifier": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.HouseNumber = value),
    //"oldmeteringpoint-street-address_StairCase": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.Staircase = value),
    //"oldmeteringpoint-street-address_Apartment": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.Apartment = value),
    "OldMPZip": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.Zip = value),
    "oldmeteringpoint-street-address_PostalCode": PropDesc.mp((contract, value) => contract.OldMeteringPoint.Address.Zip = value),
    "OldMPCode": PropDesc.mp((contract, value) => contract.OldMeteringPoint.MeteringPointCode = value),
    "MPMovingCode": PropDesc.mp((contract, value) => contract.OldMeteringPoint.MeteringPointCode = value),
    //"MovingDate": PropDesc.mp((contract, value) => contract.OldContractEndDate = value),
    "MovingDate": PropDesc.mp(null),
    "MovingMPNetworkCompany": PropDesc.mp((contract, value) => contract.OldMeteringPoint.NetworkCompanyName = value),
    //"OldContractEndDate": PropDesc.mp((contract, value) => contract.OldContractEndDate = value),
    "OldContractEndDate": PropDesc.mp(null),
    //"MoveOutDate": PropDesc.mp((contract, value) => contract.MoveOutProcess.MoveOutDate = value),
    "MoveOutDate": PropDesc.mp(null),
    "ContractReason": PropDesc.mp((contract, value) => contract.ContractReason = parseInt(value)),
    "districtHeatContractPermission": PropDesc.mp((contract, value) => contract.DistrictHeatContractPermission = parseInt(value) != 0),
    "isConnected": PropDesc.mp((contract, value) => {
        let v = parseInt(value) != 0; // Same than in new contract hub.
        contract.MeteringPoint.IsConnected = v;
        contract.IsConnected = v;
    }),
    "isSafeToConnect": PropDesc.mp((contract, value) => {
        let v = parseInt(value) != 0;
        contract.MeteringPoint.IsSafeToConnect = v;
        contract.IsSafeToConnect = v;
    }),
    //"MPStaircase": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.Staircase = value),
    //"MPHouseNumber": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.HouseNumber = value),
    //"MPApartment": PropDesc.mp((contract, value) => contract.MeteringPoint.Address.Apartment = value),
    "GsrnCode": PropDesc.mp((contract, value) => contract.MeteringPoint.GsrnCode = value),
    "IsNetted": PropDesc.mp(null),
}

const contractValues = {
    // SetContractValue
    "MoveOut": PropDesc.contract((contract, value) => contract.MoveOutProcess = null),
    "ProcessType": PropDesc.contract((contract, value) => contract.ProcessType = parseInt(value)),
    "SubProcessType": PropDesc.contract((contract, value) => contract.SubProcessType = parseInt(value)),
    "ContractTypes": PropDesc.contract((contract, value) => contract.ContractTypes = parseInt(value)),
    "ExistingContracts": PropDesc.contract((contract, value) => contract.ExistingContracts = parseInt(value)),
    "InvoicingGroup": PropDesc.contract((contract, value) => contract.InvoicingGroup = parseInt(value)),
    "DueDate": PropDesc.contract((contract, value) => contract.DueDate = parseInt(value)),
    "PaymentMethod": PropDesc.contract((contract, value) => contract.PaymentMethod = parseInt(value)),
    "RefundInvoice": PropDesc.contract((contract, value) => contract.RefundInvoice = value != null && value.length != 0),
    "ExtraInformation": PropDesc.contract((contract, value) => contract.ExtraInformation = value),
    "InvoicingNetworkAddress": PropDesc.contract((contract, value) => contract.InvoicingAddress.InvoicingNetworkAddress = value),
    "InvoicingOperator": PropDesc.contract((contract, value) => contract.InvoicingAddress.InvoicingOperator = value),
    "InvoicingDeliverCode": PropDesc.contract((contract, value) => contract.InvoicingAddress.InvoicingDeliverCode = value),
    "InvoicingFinIbanAddress": PropDesc.contract((contract, value) => contract.InvoicingAddress.InvoicingFinIbanAddress = value),
    "InvoicingFinDeliverCode": PropDesc.contract((contract, value) => contract.InvoicingAddress.InvoicingFinDeliverCode = value),
    "InvoicingFinOvtCode": PropDesc.contract((contract, value) => contract.InvoicingAddress.InvoicingFinOvtCode = value),
    "InvoicingStreetCompany": PropDesc.contract((contract, value) => contract.InvoicingAddress.Address.Street = value),
    "InvoicingZipCompany": PropDesc.contract((contract, value) => contract.InvoicingAddress.Address.Zip = value),
    "InvoicingPlaceCompany": PropDesc.contract((contract, value) => contract.InvoicingAddress.Address.Place = value),
    "InvoicingContactPersonCompany": PropDesc.contract((contract, value) => contract.InvoicingAddress.ContactPersonName = value),
    "DeliveryEmail": PropDesc.contract((contract, value) => contract.DeliveryEmail = value),
    "ExternalProductId": PropDesc.contract((contract, value) => contract.ExternalProductId = value),
    "SupplierChangeStatus": PropDesc.contract((contract, value) => contract.SupplierChangeStatus = parseInt(value)),
    "acceptTerms": PropDesc.contract((contract, value) => contract.AcceptTerms = value == "1"),
    "EnableSendingNewContractConfirmation": PropDesc.contract((contract, value) => contract.EnableSendingNewContractConfirmation = value == "1"),
    "PropertyTrade": PropDesc.contract((contract, value) => contract.PropertyTrade = value == "1" || value == "true"),
    "CreditTransfers": PropDesc.contract((contract, value) => contract.CreditTransfers = parseInt(value)),
    "ConfirmationChannel": PropDesc.contract((contract, value) => contract.ConfirmationChannel = parseInt(value)),
    "Registers": PropDesc.contract((contract, value) => contract.Registers = parseInt(value)),
    "CreditAccount": PropDesc.contract((contract, value) => contract.CreditAccount = value),
    "AnnuityInvoicing": PropDesc.contract((contract, value) => contract.AnnuityInvoicing = parseInt(value)),
    "InvoicingMethod": PropDesc.contract((contract, value) => {
        contract.InvoicingMethod == parseInt(value);
        contract.InvoicingMethodSelected = true
    }),
    "Phase": PropDesc.contract((contract, value) =>  contract.Phase = parseInt(value)),
    "MaxPhase": PropDesc.contract((contract, value) => contract.MaxPhase = parseInt(value)),
    "LoadModel": PropDesc.contract((contract, value) => contract.LoadModel = value),
    "DiscountPercent": PropDesc.contract((contract, value) => contract.DiscountPercent = parseInt(value)),
    "MembershipCode": PropDesc.contract((contract, value) => contract.MembershipCode = value),
    "PropertyOwnerName": PropDesc.contract((contract, value) => contract.PropertyOwnerName = value),
    "PropertyOwnerContactInformation": PropDesc.contract((contract, value) => contract.PropertyOwnerContactInformation = value),
    "DHInvoicingName": PropDesc.contract((contract, value) => contract.DHInvoicingName = value),
    "DHInvoicingContactInformation": PropDesc.contract((contract, value) => contract.DHInvoicingContactInformation = value),
    //"StartDate": PropDesc.contract((contract, value) => contract.StartDate = value),
    "StartDate": PropDesc.contract(null),
    //"FixedTermEndDate": PropDesc.contract((contract, value) => contract.FixedTermEndDate = value),
    "FixedTermEndDate": PropDesc.contract(null),
    "MovingMPStreet": PropDesc.contract((contract, value) => contract.OldMeteringPoint.Address.Street = value),
    "MovingMPZip": PropDesc.contract((contract, value) => contract.OldMeteringPoint.Address.Zip = value),
    "MPMovingCode": PropDesc.contract((contract, value) => contract.OldMeteringPoint.MeteringPointCode = value),
    //"MovingDate": PropDesc.contract((contract, value) => contract.OldContractEndDate = value),
    "MovingDate": PropDesc.contract(null),
    //"OldFixedTermContractEndDateByUser": PropDesc.contract((contract, value) => contract.OldFixedTermContractEndDateByUser = value), // TODO: Check this!
    "OldFixedTermContractEndDateByUser": PropDesc.contract(null), // TODO: Check this!
    "NewCalculatedStartDate": PropDesc.contract((contract, value) => { }), // TODO: Check this
    "OldSalesCompany": PropDesc.contract((contract, value) => contract.OldSalesCompany = value),
    "ContractReason": PropDesc.contract((contract, value) => contract.ContractReason = parseInt(value)),
    "ConnectionFee": PropDesc.contract((contract, value) => contract.ConnectionFee = value == "" ? 0 : parseFloat(value)),
    "ContractSpecificBasicPrice": PropDesc.contract((contract, value) => contract.ContractSpecificBasicPrice = value == "" ? null : parseFloat(value)),
    "ContractSpecificEnergy1Price": PropDesc.contract((contract, value) => contract.ContractSpecificEnergy1Price = value == "" ? null : parseFloat(value)),
    "ContractSpecificEnergy2Price": PropDesc.contract((contract, value) => contract.ContractSpecificEnergy2Price = value == "" ? null : parseFloat(value)),
    "OldContractCode": PropDesc.contract((contract, value) => contract.OldContractCode = value),
    "OldContract": PropDesc.contract((contract, value) => contract.OldContract = parseInt(value) != 0),
    "ExtranetContract": PropDesc.contract((contract, value) => contract.ExtranetContract = parseInt(value) != 0),
    "connectionContractTransfers": PropDesc.contract((contract, value) => contract.ConnectionContractTransfers = parseInt(value) != 0),
    "ContinuationContract": PropDesc.contract((contract, value) => contract.ContinuationContract = value),
    "ProductChangeProcess": PropDesc.contract((contract, value) => contract.ProductChangeProcess = value != null && (value == "1" || value.toLowerCase() == "true")),
    "ConfirmationCOName": PropDesc.contract((contract, value) => contract.ConfirmationAddress.COName = value),
    "ConfirmationStreet": PropDesc.contract((contract, value) => contract.ConfirmationAddress.Street = value),
    "ConfirmationZip": PropDesc.contract((contract, value) => contract.ConfirmationAddress.Zip = value), // TODO: Figure out post office
    "MPTarificationId": PropDesc.contract((contract, value) => contract.TarificationId = parseInt(value)),
    //"ContractDate": PropDesc.contract((contract, value) => contract.ContractDate = value), // TODO: check this
    "ContractDate": PropDesc.contract(null), // TODO: check this
    "ContractOrigin": PropDesc.contract((contract, value) => {
        if (value != null && value.length == 6) {
            contract.ContractOriginInfo.Origin = value.substr(0, 4);
            contract.ContractOriginInfo.Channel = value.substr(4);
        }
    }),
    "ContractOriginInfo": PropDesc.contract((contract, value) => {
        if (value != null && value.length == 4)
            contract.ContractOriginInfo.Origin = value
    }),
    "ContractOriginChannel": PropDesc.contract((contract, value) => {
        if (value != null && value.length == 2)
            contract.ContractOriginInfo.Channel = value
    }),
    "InvoicingMethodSelected": PropDesc.contract((contract, value) => contract.InvoicingMethodSelected = value != null && (value == "1" || value.toLowerCase() == "true")),
    "PaperInvoiceAllowed": PropDesc.contract((contract, value) => contract.PaperInvoiceAllowed = value != null && (value == "1" || value.toLowerCase() == "true")),
    // Already as basic value.
    // "ExtraServiceOrder": PropDesc.contract((contract, value) => contract.ExtraServiceOrder = parseInt(value))
    "DocumentTemplateName": PropDesc.contract((contract, value) => contract.DocumentTemplateName = value),
    "MarketingPermissionEmailCustomer": PropDesc.contract((contract, value) => contract.MarketingPermissionEmailCustomer = value != null && (value == "1" || value.toLowerCase() == "true")),
    "DirectMarketingSelected": PropDesc.contract((contract, value) => contract.DirectMarketingSelected = value != null && (value == "1" || value.toLowerCase() == "true")),
    "ServiceProduct": PropDesc.contract(null),
    "IsEstateOwner": PropDesc.contract((contract, value) => contract.IsEstateOwner = Boolean(value)),
    "IsNetted": PropDesc.contract(null),
    "MembershipType": PropDesc.contract((contract, value) => contract.MembershipType = parseInt(value)),
    "ContractToNewAddress": PropDesc.contract((contract, value) => contract.ContractToNewAddressSelection = parseInt(value))
}

const customerValues = {
    // SetCustomerValue
    "AddressValidFrom": PropDesc.customer(null),
    "ExistingCustomer": PropDesc.customer(null),
    "CustomerCode": PropDesc.customer(null),
    "SourceCompanyCode": PropDesc.customer(null),
    "FirstName": PropDesc.customer(null),
    "LastName": PropDesc.customer(null),
    "Pin": PropDesc.customer(null),
    "COName": PropDesc.customer(null),
    "Street": PropDesc.customer(null),
    "street-address_Street": PropDesc.customer(null),
    "StreetName": PropDesc.customer(null),
    "street-address_StreetName": PropDesc.customer(null),
    "street-address_StreetQualifier": PropDesc.customer(null),
    "street-address_StairCase": PropDesc.customer(null),
    "street-address_Apartment": PropDesc.customer(null),
    "Zip": PropDesc.customer(null),
    "street-address_PostalCode": PropDesc.customer(null),
    "Place": PropDesc.customer(null),
    "street-address_City": PropDesc.customer(null),
    "Country": PropDesc.customer(null),
    "street-address_Country": PropDesc.customer(null),
    "Email": PropDesc.customer(null),
    "Phone": PropDesc.customer(null),
    "SBonusCode": PropDesc.customer(null),
    "MarketingChannelSMS": PropDesc.customer(null),
    "MarketingChannelEmail": PropDesc.customer(null),
    "MarketingChannelElec": PropDesc.customer(null),
    "MarketingChannelSMSAndEmail": PropDesc.customer(null),
    "DirectMarketing": PropDesc.customer(null),
    "HasMarketingBan": PropDesc.customer(null),
    "HasMarketingBanPhoneFromContractProcess": PropDesc.customer(null),
    "HasMarketingBanEmailFromContractProcess": PropDesc.customer(null),
    "MarketingEmail": PropDesc.customer(null),
    "MarketingPhone": PropDesc.customer(null),
    "Staircase": PropDesc.customer(null),
    "HouseNumber": PropDesc.customer(null),
    "Apartment": PropDesc.customer(null),
    "EPaymentCode": PropDesc.customer(null),
    "EPaymentOperator": PropDesc.customer(null),
    "FirstName__contractpartner-1": PropDesc.customer(null),
    "LastName__contractpartner-1": PropDesc.customer(null),
    "Pin__contractpartner-1": PropDesc.customer(null),
    "Street__contractpartner-1": PropDesc.customer(null),
    "contractpartner1-street-address_Street": PropDesc.customer(null),
    "contractpartner1-street-address_StreetName": PropDesc.customer(null),
    "contractpartner1-street-address_StreetQualifier": PropDesc.customer(null),
    "contractpartner1-street-address_StairCase": PropDesc.customer(null),
    "contractpartner1-street-address_Apartment": PropDesc.customer(null),
    "Zip__contractpartner-1": PropDesc.customer(null),
    "contractpartner1-street-address_PostalCode": PropDesc.customer(null),
    "Email__contractpartner-1": PropDesc.customer(null),
    "Phone__contractpartner-1": PropDesc.customer(null),
    "FirstName__contractpartner-2": PropDesc.customer(null),
    "LastName__contractpartner-2": PropDesc.customer(null),
    "Pin__contractpartner-2": PropDesc.customer(null),
    "Street__contractpartner-2": PropDesc.customer(null),
    "contractpartner2-street-address_Street": PropDesc.customer(null),
    "contractpartner2-street-address_StreetName": PropDesc.customer(null),
    "contractpartner2-street-address_StreetQualifier": PropDesc.customer(null),
    "contractpartner2-street-address_StairCase": PropDesc.customer(null),
    "contractpartner2-street-address_Apartment": PropDesc.customer(null),
    "Zip__contractpartner-2": PropDesc.customer(null),
    "contractpartner2-street-address_PostalCode": PropDesc.customer(null),
    "Email__contractpartner-2": PropDesc.customer(null),
    "Phone__contractpartner-2": PropDesc.customer(null),
    "FirstName__contractpartner-3": PropDesc.customer(null),
    "LastName__contractpartner-3": PropDesc.customer(null),
    "Pin__contractpartner-3": PropDesc.customer(null),
    "Street__contractpartner-3": PropDesc.customer(null),
    "contractpartner3-street-address_Street": PropDesc.customer(null),
    "contractpartner3-street-address_StreetName": PropDesc.customer(null),
    "contractpartner3-street-address_StreetQualifier": PropDesc.customer(null),
    "contractpartner3-street-address_StairCase": PropDesc.customer(null),
    "contractpartner3-street-address_Apartment": PropDesc.customer(null),
    "Zip__contractpartner-3": PropDesc.customer(null),
    "contractpartner3-street-address_PostalCode": PropDesc.customer(null),
    "Email__contractpartner-3": PropDesc.customer(null),
    "Phone__contractpartner-3": PropDesc.customer(null),
    "FirstName__contractpartner-4": PropDesc.customer(null),
    "LastName__contractpartner-4": PropDesc.customer(null),
    "Pin__contractpartner-4": PropDesc.customer(null),
    "Street__contractpartner-4": PropDesc.customer(null),
    "contractpartner4-street-address_Street": PropDesc.customer(null),
    "contractpartner4-street-address_StreetName": PropDesc.customer(null),
    "contractpartner4-street-address_StreetQualifier": PropDesc.customer(null),
    "contractpartner4-street-address_StairCase": PropDesc.customer(null),
    "contractpartner4-street-address_Apartment": PropDesc.customer(null),
    "Zip__contractpartner-4": PropDesc.customer(null),
    "contractpartner4-street-address_PostalCode": PropDesc.customer(null),
    "Email__contractpartner-4": PropDesc.customer(null),
    "Phone__contractpartner-4": PropDesc.customer(null),
    "FirstName__contractpartner-5": PropDesc.customer(null),
    "LastName__contractpartner-5": PropDesc.customer(null),
    "Pin__contractpartner-5": PropDesc.customer(null),
    "Street__contractpartner-5": PropDesc.customer(null),
    "contractpartner5-street-address_Street": PropDesc.customer(null),
    "contractpartner5-street-address_StreetName": PropDesc.customer(null),
    "contractpartner5-street-address_StreetQualifier": PropDesc.customer(null),
    "contractpartner5-street-address_StairCase": PropDesc.customer(null),
    "contractpartner5-street-address_Apartment": PropDesc.customer(null),
    "Zip__contractpartner-5": PropDesc.customer(null),
    "contractpartner5-street-address_PostalCode": PropDesc.customer(null),
    "Email__contractpartner-5": PropDesc.customer(null),
    "Phone__contractpartner-5": PropDesc.customer(null),
    "CompanyName": PropDesc.customer(null),
    "BusinessId": PropDesc.customer(null),
    "CompanyCOName": PropDesc.customer(null),
    "CompanyStreet": PropDesc.customer(null),
    "companystreet-address_Street": PropDesc.customer(null),
    "CompanyStreetName": PropDesc.customer(null),
    "companystreet-address_StreetName": PropDesc.customer(null),
    "CompanyZip": PropDesc.customer(null),
    "companystreet-address_PostalCode": PropDesc.customer(null),
    "CompanyPlace": PropDesc.customer(null),
    "companystreet-address_City": PropDesc.customer(null),
    "CompanyCountry": PropDesc.customer(null),
    "companystreet-address_Country": PropDesc.customer(null),
    "companystreet-address_StreetQualifier": PropDesc.customer(null),
    "companystreet-address_StairCase": PropDesc.customer(null),
    "companystreet-address_Apartment": PropDesc.customer(null),
    "CompanyEmail": PropDesc.customer(null),
    "CompanyPhone": PropDesc.customer(null),
    "CompanyMarketingChannelSMS": PropDesc.customer(null),
    "CompanyMarketingChannelEmail": PropDesc.customer(null),
    "CompanyHasMarketingBanPhoneFromContractProcess": PropDesc.customer(null),
    "CompanyHasMarketingBanEmailFromContractProcess": PropDesc.customer(null),
    "CompanyMarketingEmail": PropDesc.customer(null),
    "CompanyMarketingPhone": PropDesc.customer(null),
    "CompanyStaircase": PropDesc.customer(null),
    "CompanyHouseNumber": PropDesc.customer(null),
    "CompanyApartment": PropDesc.customer(null),
    "CompanyEPaymentCode": PropDesc.customer(null),
    "CompanyEPaymentOperator": PropDesc.customer(null),
    "FirstName__contactperson-1": PropDesc.customer(null),
    "LastName__contactperson-1": PropDesc.customer(null),
    "Pin__contactperson-1": PropDesc.customer(null),
    "Street__contactperson-1": PropDesc.customer(null),
    "Zip__contactperson-1": PropDesc.customer(null),
    "Email__contactperson-1": PropDesc.customer(null),
    "Phone__contactperson-1": PropDesc.customer(null),
    "FirstName__contactperson-2": PropDesc.customer(null),
    "LastName__contactperson-2": PropDesc.customer(null),
    "Pin__contactperson-2": PropDesc.customer(null),
    "Street__contactperson-2": PropDesc.customer(null),
    "Zip__contactperson-2": PropDesc.customer(null),
    "Email__contactperson-2": PropDesc.customer(null),
    "Phone__contactperson-2": PropDesc.customer(null),
    "IsInvoicingAddressInUse": PropDesc.customer(null),
    "IsCustomerAddressInUse": PropDesc.customer(null),
    "InvoicingContactPerson": PropDesc.customer(null),
    "InvoicingContactPersonEmail": PropDesc.customer(null),
    "InvoicingStreet": PropDesc.customer(null),
    "inv-address_Street": PropDesc.customer(null),
    "MPStreetName": PropDesc.customer(null),
    "inv-address_StreetName": PropDesc.customer(null),
    "inv-address_StreetQualifier": PropDesc.customer(null),
    "inv-address_StairCase": PropDesc.customer(null),
    "inv-address_Apartment": PropDesc.customer(null),
    "InvoicingZip": PropDesc.customer(null),
    "inv-address_PostalCode": PropDesc.customer(null),
    "InvoicingPlace": PropDesc.customer(null),
    "inv-address_City": PropDesc.customer(null),
    "InvoicingCountry": PropDesc.customer(null),
    "InvoicingCOName": PropDesc.customer(null),
    "OtherAddressSelected": PropDesc.customer(null),
    "ServiceChannelCode": PropDesc.customer(null),
    "CompanyServiceChannelCode": PropDesc.customer(null),
    "language-selection": PropDesc.customer(null),
    "companylanguage-selection": PropDesc.customer(null),
    "authenticationAccepted": PropDesc.customer(null),
}

const server = $.connection.newContractHub.server;

class ServerApi {
    static setMeteringPointValue(key: string, value: string, locale?: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            console.log("SetMeteringPointValue: " + key + ": " + value);
            try {
                server.setMeteringPointValue(key, value, locale).done((msg: string) => {
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static setValue(key: string, value: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            console.log("SetValue: " + key + ": " + value);
            try {
                server.setValue(key, value).done((msg: string) => {
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static setContractValue(key: string, value: string, locale?: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            console.log("SetContractValue: " + key + ": " + value);
            try {
                server.setContractValue(key, value, locale).done((msg: string) => {
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static setCustomerValue(key: string, value: string, locale?: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            console.log("SetCustomerValue: " + key + ": " + value);
            try {
                server.setCustomerValue(key, value, locale).done((msg: string) => {
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static getContractData(): Promise<IContractViewModel> {
        return new Promise<IContractViewModel>((resolve, reject) => {
            try {
                server.getContractData().done((contract: IContractViewModel) => {
                    resolve(contract);
                }).fail(() => {
                    reject("Failed to get contract data!");
                });
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static setProduct(productId: number, priceListId: number): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            let val = "p-" + productId + "-" + priceListId;
            try {
                server.setProduct(val).done((msg: string) => {
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    console.log(msg);
                    resolve(msg);
                }).fail(() => {
                    reject("Failed to set product!");
                });
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static getSelectedProduct(): Promise<IProductViewModel> {
        return new Promise<IProductViewModel>((resolve, reject) => {
            try {
                server.getSelectedProduct().done(function (productViewModel: IProductViewModel) {
                    resolve(productViewModel);
                }).fail(() => {
                    reject("Failed to get selected product!");
                });
            }
            catch (ex)
            {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static setContractPartners(contractPartners: IContactPersonViewModel[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            try {
                server.setContractPartners(contractPartners).done(() => {
                    resolve();
                }).fail(() => reject());
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static addMeteringPointToMoveOut(mp: string, utility: number, moveoutReason: MoveOutReasonEnum, moveoutDate: string): Promise<string> {
        let self = this;
        return new Promise<string>((resolve, reject) => {
            console.log(`server addMeteringPointToMoveOut - mp: ${mp}, utility: ${utility}, moveoutReason: ${moveoutReason}, moveoutDate: ${moveoutDate}`);
            try {
                server.addMeteringPointToMoveOutProcess(mp, utility, moveoutReason, moveoutDate)
                    .done((msg: string) => {
                        console.log(msg);
                        if (msg && msg.indexOf("Error:") == 0) {
                            reject(msg);
                            return;
                        }
                        resolve(msg);
                    }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex)
            {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static removeMeteringPointFromMoveOut(mp: string, utility: number): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            console.log("server removeMeteringPointFromMoveOut: " + mp + " " + utility);
            try {
                server.removeMeteringPointFromMoveOutProcess(mp, utility).done((msg: string) => {
                    console.log(msg);
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static setMoveOutDate(movingDate: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            console.log("server setMoveOutDate: " + movingDate);
            try {
                server.setMeteringPointValue("MoveOutDate", movingDate).done((msg: string) => {
                    console.log(msg);
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static hasCustomerValidPin(pin: string): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            console.log("server hasCustomerValidPin: " + pin);
            try {
                server.hasCustomerValidPin("pin", pin).done((msg: string) => {
                    console.log(msg);
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }

                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static isCustomerInCIS(pin: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            console.log("server isCustomerInCIS");
            try {
                server.isCustomerInCIS(pin).done((retVal: boolean) => {
                    console.log("result: " + retVal);
                    resolve(retVal);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }

    static getSelectedServiceProducts(): Promise<ISelectedServiceProductViewModel[]> {
        return new Promise<ISelectedServiceProductViewModel[]>((resolve, reject) => {
            try {
                server.getSelectedServiceProducts().done((retVal: ISelectedServiceProductViewModel[]) => {
                    console.log("server getSelectedServiceProducts done, length: " + retVal.length);
                    resolve(retVal);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }

    static checkMeteringPointAndContract(streetAddress: string, zipCode: string, externalMP: boolean, customerType: CustomerTypeEnum, pin: string) {
        return new Promise<void>((resolve, reject) => {
            console.log("CheckMeteringPointAndContract: " + streetAddress + ", " + zipCode);
            try {
                server.checkMeteringPointAndContract(streetAddress, zipCode, externalMP, customerType, pin).done(retVal => {
                    resolve(retVal);
                }).fail((x) => reject("Error calling NewContractHub!: " + x));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }

    static checkMeteringPointAndContractV2(streetAddress: string, zipCode: string, externalMP: boolean, customerType: CustomerTypeEnum, pin: string, gsrn: string) {
        return new Promise<void>((resolve, reject) => {
            console.log("CheckMeteringPointAndContractV2: " + streetAddress + ", " + zipCode + ", " + gsrn);
            try {
                server.checkMeteringPointAndContract(streetAddress, zipCode, externalMP, customerType, pin, gsrn).done(retVal => {
                    resolve(retVal);
                }).fail((x) => reject("Error calling NewContractHub!: " + x));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static getHolidays(years: number): Promise<string[]> {
        return new Promise<string[]>((resolve, reject) => {
            try {
                server.getHolidays(years).done(res => {
                    resolve(res.Data);
                }).fail(ex => {
                    reject("error getting holidays from hub: " + ex);
                });
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        }); 
    }
    static loadMembershipTypes(): Promise<IMembershipTypeViewModel[]> {
        return new Promise<IMembershipTypeViewModel[]>((resolve, reject) => {
            try {
                server.getMembershipTypes().done(res => {
                    resolve(res);
                }).fail(ex => {
                    reject("error getting membershipTypes from hub: " + ex);
                });
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static removeAndUpdateExtraFeature(originalname: string, name: string, amount: number, price: number) {
        return new Promise<string>((resolve, reject) => {
            console.log("server remove extrafeature: " + name + ":" + amount + ":" + price);
            try {
                server.removeExtraFeature(originalname).done((msg: string) => {
                    console.log(msg);
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }

    static updateExtraFeature(name: string, amount: number, price:number) {
        return new Promise<string>((resolve, reject) => {
            console.log("server update extrafeature: " + name + ":" + amount + ":" + price);
            try {
                server.updateExtraFeature(name, amount, price).done((msg: string) => {
                    console.log(msg);
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
    static setOfferProducts(offerProducts: string[]) {
        return new Promise<string>((resolve, reject) => {
            console.log("set offer products" + offerProducts);
            try {
                server.setProducts(offerProducts).done((msg: string) => {
                    console.log(msg);
                    if (msg && msg.indexOf("Error:") == 0) {
                        reject(msg);
                        return;
                    }
                    resolve(msg);
                }).fail(() => reject("Error calling NewContractHub!"));
            }
            catch (ex) {
                console.log("error: " + ex);
                NewContractEvents.notifySessionExpired();
            }
        });
    }
}

function getValueSetter(type: PropertyTypeEnum): Function {
    switch (type) {
        case PropertyTypeEnum.BasicValue:
            return ServerApi.setValue;
        case PropertyTypeEnum.ContractValue:
            return ServerApi.setContractValue;
        case PropertyTypeEnum.CustomerValue:
            return ServerApi.setCustomerValue;
        case PropertyTypeEnum.MeteringPointValue:
            return ServerApi.setMeteringPointValue;
    }
    return null;
}

function findPropertyDescriptor(key: string): PropDesc {
    let d = basicValues[key];
    if (d == null)
        d = contractValues[key];
    if (d == null)
        d = meteringPointValues[key];
    if (d == null)
        d = customerValues[key];
    return d;
}

const store: StoreOptions<INewContractState> = {
    state: state,
    getters: {
        // Returns company name for company customer and <FirstName> <LastName> for consumer customer.
        customerName: (state: INewContractState) => {
            switch (state.contract.CustomerType) {
                case CustomerTypeEnum.COMPANY: return state.contract.Company.CompanyName;
                case CustomerTypeEnum.CONSUMER: {
                    let str = "";
                    [state.contract.Customer.FirstName, state.contract.Customer.LastName].forEach((x) => {
                        if (x) {
                            if (str)
                                str += " ";
                            str += x;
                        }
                    })
                    return str;
                }
                default:
                    return null;
            }
        },
        customerIdentifier: (state: INewContractState) => {
            switch (state.contract.CustomerType) {
                case CustomerTypeEnum.COMPANY: return state.contract.Company.BusinessId;
                case CustomerTypeEnum.CONSUMER: return state.contract.Customer.Pin;
                default:
                    return null;
            }
        },
        customerPhone: (state: INewContractState) => {
            switch (state.contract.CustomerType) {
                case CustomerTypeEnum.COMPANY: return state.contract.Company.Phone;
                case CustomerTypeEnum.CONSUMER: return state.contract.Customer.Phone;
                default:
                    return null;
            }
        },
        customerEmail: (state: INewContractState) => {
            switch (state.contract.CustomerType) {
                case CustomerTypeEnum.COMPANY: return state.contract.Company.Email;
                case CustomerTypeEnum.CONSUMER: return state.contract.Customer.Email;
                default:
                    return null;
            }
        },
        customerAddress: (state: INewContractState) => {
            switch (state.contract.CustomerType) {
                case CustomerTypeEnum.COMPANY: return state.contract.Company.Address;
                case CustomerTypeEnum.CONSUMER: return state.contract.Customer.Address;
                default:
                    return null;
            }
        },
        loadingNewPhase(state: INewContractState, loadingNewPhase: boolean) {
            return state.loadingNewPhase;
        },
        isUserAuthenticated(state: INewContractState, isUserAuthenticated: boolean) {
            return state.isUserAuthenticated;
        },
        offerProducts(state: INewContractState) {
            return state.offerProducts;
        },
        strongContractAuthentication: (state: INewContractState) => {
            return state.contract.StrongContractAuthentication;
        },
        contractToNewAddressSelection: (state: INewContractState) => {
            return state.contract.ContractToNewAddressSelection;
        }
    },
    mutations: {
        setNewContractInitialized(state: INewContractState) {
            state.newContractInitialized = true;
        },
        setAutoClearSelectedProduct(state: INewContractState, autoClear: boolean) {
            state.autoClearSelectedProduct = autoClear;
        },
        updateContract(state: INewContractState, contract: IContractViewModel) {
            state.contract = contract;
        },
        updateProducts(state: INewContractState, payload: { products: IProductViewModel[] }) {
            state.products = payload.products;
        },
        changeValue(state: INewContractState, payload: { propertyDescriptor: PropDesc, value: string }) {
            payload.propertyDescriptor.changeValue(state.contract, payload.value);
        },
        consumptionUpdated(state: INewContractState, payload: { energy1: number, energy2: number }) {
            state.contract.Energy1 = payload.energy1;
            state.contract.Energy2 = payload.energy2;
        },
        setSelectedProduct(state: INewContractState, payload: { product: IProductViewModel, priceList: IPriceListViewModel }) {
            state.selectedProduct = payload.product;
            state.selectedPriceList = payload.priceList;
            state.contract.ProductId = payload.product != null ? payload.product.Id : 0;
            state.contract.PriceListId = payload.priceList != null ? payload.priceList.Id : 0;
        },
        setSelectedServiceProducts(state: INewContractState, payload: { selectedServiceProducts: string[] }) {
            state.selectedServiceProducts = payload.selectedServiceProducts;
        },
        addContractPartner(state: INewContractState, contractPartner: IContactPersonViewModel) {
            switch (state.contract.CustomerType) {
                case CustomerTypeEnum.CONSUMER:
                    state.contract.Customer.ContractPartners.push(contractPartner);
            }
        },
        setPreSelectedProductPriceListTarification(state: INewContractState, preSelected: boolean) {
            state.preSelectedProductPriceListTarification = preSelected;
        },
        setPreSelectedProductId(state: INewContractState, preSelected: number) {
            state.preSelectedProductId = preSelected;
        },
        setPreSelectedPriceListId(state: INewContractState, preSelected: number) {
            state.preSelectedPriceListId = preSelected;
        },  
        setPreSelectedMembership(state: INewContractState, preSelected: string) {
            state.preSelectedMembership = preSelected;
        },
        setMembership(state: INewContractState, membership: string) {
            state.contract.MembershipCode = membership;
        },        
        isAuthenticated(state: INewContractState, isAuthenticated: boolean) {
            state.isAuthenticated = isAuthenticated;
        },
        setHolidays(state: INewContractState, holidays: string[]) {
            state.holidays = holidays;
        },
        setMembershipTypes(state: INewContractState, membershipTypes: IMembershipTypeViewModel[]) {
            state.membershipTypes = membershipTypes;
        },
        setloadingNewPhase(state: INewContractState, loadingNewPhase: boolean) {
            state.loadingNewPhase = loadingNewPhase;
        },
        isUserAuthenticated(state: INewContractState, isUserAuthenticated: boolean) {
            state.isUserAuthenticated = isUserAuthenticated;
        },
        setConinueWithSameProductIdAndPricelistId(state: INewContractState, payload: { productId: number, priceListId: number}) {
            state.selectedConinueWithSameProductId = payload.productId;
            state.selectedConinueWithSamePriceListId = payload.priceListId;
        },
        offerRequest(state: INewContractState, preSelected: boolean) {
            state.offerRequest = preSelected;
        },
        setContractToNewAddressSelection: (state: INewContractState, newSelection: number) => {
            state.contract.ContractToNewAddressSelection = newSelection;
        }
    },
    actions: {
        refreshContract(ctx) {
            return ServerApi.getContractData().then((contract: IContractViewModel) => {
                if (ctx.state.contract.MembershipCode) {
                    contract.MembershipCode = ctx.state.contract.MembershipCode;
                }
                ctx.commit("updateContract", contract);
            });
        },
        changeValue(ctx, payload: { key: string, value: string; type: PropertyTypeEnum }) {
            return ctx.dispatch("changeValues", [payload]);
        },
        // Call change value for given key-value pairs, and then refresh contract from the server.
        changeValues(ctx, payloads: { key: string, value: string, locale?: string, type?: PropertyTypeEnum }[]) {
            console.log("NewContractStore.actions.changeValues");
            return new Promise<void>((resolve, reject) => {
                let deferredUpdates: Promise<string>[] = [];
                let errorMessages: string[] = [];
                // Track if server data has been updated.
                let dirty = false;
                payloads.forEach((payload) => {
                    let type = payload.type;
                    let propDesc = findPropertyDescriptor(payload.key);
                    if (propDesc == null && type == null) {
                        errorMessages.push("Could not find property descriptor for [" + payload.key + "]");
                        return;
                    }

                    if (type == null)
                        type = propDesc.type;

                    // Get the correct setter method based on type (i.e. whether we should call SetValue, SetContractValue etc.).
                    let func = getValueSetter(type);
                    if (func != null) {
                        // Call the server and store the Promise it returns.
                        let setterPromise = func(payload.key, payload.value, payload.locale)
                            .then((msg: string) => {
                                console.log(msg);
                                // At least one server call managed to update data successfully.
                                dirty = true;
                                // TODO: Instead of refreshing the contract from the server, it could be possible to update client side model here.
                                // ctx.commit("changeValue", { propertyDescriptor: propDesc, value: payload.value });
                            })
                            // If the returned promise is rejected, let's catch that rejection here and store possible error message.
                            .catch((error: string) => {
                                errorMessages.push(error);
                            });
                        deferredUpdates.push(setterPromise);
                    }
                    else {
                        errorMessages.push("Unknown property type!");
                    }
                });

                Promise.all(deferredUpdates)
                    .then(() => {
                        if (dirty) {
                            ctx.dispatch("refreshContract").catch((errorMsg: string) => {
                                errorMessages.push("Failed to refresh contract from the server after value change.");
                            }).then(() => {
                                if (errorMessages.length != 0)
                                    reject(errorMessages.join("\n"))
                                else
                                    resolve();
                            });
                        }
                        else {
                            if (errorMessages.length != 0)
                                reject(errorMessages.join("\n"))
                            else
                                resolve();
                        }
                    })
                    .catch((msg) => {
                        reject("Unexptected error!");
                    });
            });
        },
        updateProducts(ctx, payload: { products: IProductViewModel[] }) {
            let state: INewContractState = ctx.state;
            if (state.autoClearSelectedProduct) {
                // Clear selected product if it does not exist in refreshed products.
                if (state.contract.ProductId != 0 && state.contract.PriceListId != 0) {
                    let product = find(payload.products, x => x.Id == state.contract.ProductId);
                    let priceList = product != null && product.PriceLists != null
                        ? find(product.PriceLists, x => x.Id == state.contract.PriceListId)
                        : null;

                    if (product == null || priceList == null) {
                        // Currently selected product not found from updated products, let's clear the selection.
                        ctx.dispatch("selectProduct", { product: null, priceList: null })
                            .then(() => {
                                NewContractEvents.notifyProductSelectionCleared();
                            });
                    }
                    else {
                        ctx.commit("setSelectedProduct", { product: product, priceList: priceList });
                    }
                }
            }
            ctx.commit("updateProducts", { products: payload.products });
        },
        selectProductById(ctx, payload: { productId: number, priceListId: number }) {
            return ServerApi.setProduct(payload.productId, payload.priceListId)
                .then(ServerApi.getSelectedProduct)
                .then((productViewModel: IProductViewModel) => {
                    let product = productViewModel;
                    let priceList = productViewModel.PriceLists[0];
                    ctx.commit("setSelectedProduct", { product: product, priceList: priceList });
                });
        },
        selectProduct(ctx, payload: { product: IProductViewModel, priceList: IPriceListViewModel }) {
            let productId = payload.product != null ? payload.product.Id : 0;
            let priceListId = payload.priceList != null ? payload.priceList.Id : 0;
            return ServerApi.setProduct(productId, priceListId)
                .then(() => {
                    ctx.commit("setSelectedProduct", payload);
                });
        },
        setContractPartners(ctx, contractPartners: IContactPersonViewModel[]) {
            return ServerApi.setContractPartners(contractPartners)
                .then(() => {
                    ctx.dispatch("refreshContract");
                });
        },
        setMoveOutDate(ctx, payload: { moveOutDate: string }) {
            console.log("Store: setMoveOutDate: " + payload.moveOutDate);
            return ServerApi.setMoveOutDate(payload.moveOutDate)
                .then(() => {
                    ctx.dispatch("refreshContract");
                    //ctx.state.contract.MoveOutProcess.MoveOutDate = payload.moveOutDate;
                });
        },
        updateUserName(ctx, payload: { userName: string }) {
            ctx.state.moveOutUser = payload.userName;
        },
        isUserAuthenticated(ctx, payload: { isUserAuthenticated: boolean }) {
            ctx.state.isUserAuthenticated = payload.isUserAuthenticated;
        },
        offerRequest(ctx, payload: { offerRequest: boolean }) {
            ctx.state.offerRequest = payload.offerRequest;
        },
        isPinSetInDb(ctx, payload: { pinSet: string}) {
            console.log("isPinSetInDb: " +payload.pinSet);
        },
        /*showActiveContracts(ctx, payload: { contracts: IContractViewModel[] }) {
            console.log("showActiveContracts: " + payload.contracts);
            for (let i = 0; i < payload.contracts.length; i++) {
                console.log(payload.contracts[i]);
            }
            ctx.state.moveOutContracts = payload.contracts;
        },*/
        addMeteringPointToMoveOut(ctx, payload: { mp: string, utility: number, moveoutReason: MoveOutReasonEnum, moveoutDate: string }) {
            console.log(`addMeteringPointToMoveOut: ${payload.mp} ${payload.utility}`);
            return ServerApi.addMeteringPointToMoveOut(payload.mp, payload.utility, payload.moveoutReason, payload.moveoutDate)
                .then(() => {
                    ctx.dispatch("refreshContract");
                });
        },
        removeMeteringPointFromMoveOut(ctx, payload: { mp: string, utility: number }) {
            console.log("removeMeteringPointFromMoveOut: " + payload.mp + " " + payload.utility);
            return ServerApi.removeMeteringPointFromMoveOut(payload.mp, payload.utility)
                .then(() => {
                    ctx.dispatch("refreshContract");
                });
        },
        checkMeteringPointAndContract(ctx) {
            if (!ctx.state.contract.MeteringPoint.Address.Street || !ctx.state.contract.MeteringPoint.Address.Zip) {
                var mp = ctx.state.contract.MeteringPoint;
                if (mp.GsrnCode) {
                    ctx.dispatch("changeValue", { key: "GsrnCode", value: null });
                }                
            }
            if (ctx.state.contract.MeteringPoint.Address.Street && ctx.state.contract.MeteringPoint.Address.Zip) {
                var mp = ctx.state.contract.MeteringPoint;
                var streetAddress = mp.Address.Street;
                var zipCode = mp.Address.Zip;
                var isExternalMP = true;
                var customerType = ctx.state.contract.CustomerType;
                var identifier = customerType == CustomerTypeEnum.COMPANY
                    ? ctx.state.contract.Company.BusinessId
                    : ctx.state.contract.Customer.Pin;

                return new Promise<void>((resolve, reject) => {
                    ServerApi.checkMeteringPointAndContract(streetAddress, zipCode, isExternalMP, customerType, identifier).then((retVal: any) => {
                        // Data might have changed, let's refresh contract on the client side.
                        ctx.dispatch("refreshContract").then(() => {
                            resolve();
                        });
                    });
                });
            }
            return Promise.resolve();
        },
        checkMeteringPointAndContractV2(ctx) {
            var mp = ctx.state.contract.MeteringPoint;
            var isExternalMP = true;
            var customerType = ctx.state.contract.CustomerType;
            var identifier = customerType == CustomerTypeEnum.COMPANY
                ? ctx.state.contract.Company.BusinessId
                : ctx.state.contract.Customer.Pin;
            var streetAddress = null;
            var zipCode = null;
            var gsrn = null;

            mp.IsNetted = null;
            mp.EnergyCommunityName = null;
            mp.EnergyCommunityCode = null;
            mp.RelatedMeteringPoint = null;
             
            if (mp.GsrnCode) {
                gsrn = mp.GsrnCode;
            }
            else if (mp.Address.Street || mp.Address.Zip) {
                streetAddress = mp.Address.Street;
                zipCode = mp.Address.Zip;
            }
            if (streetAddress || zipCode || gsrn) {
                return new Promise<void>((resolve, reject) => {
                    ServerApi.checkMeteringPointAndContractV2(streetAddress, zipCode, isExternalMP, customerType, identifier, gsrn).then((retVal: any) => {
                        // Data might have changed, let's refresh contract on the client side.
                        ctx.dispatch("refreshContract").then(() => {
                            resolve();
                        });
                    });
                });
            }
        },
        isCustomerInCIS(ctx, payload: { pin: string }) {
            console.log("isCustomerInCIS");
            return ServerApi.isCustomerInCIS(payload.pin);
        },
        getSelectedServiceProducts(ctx) {
            return ServerApi.getSelectedServiceProducts();
        },
        getHolidays(ctx, payload: { years: number }) {
            console.log("getHolidays: " + payload.years);
            return ServerApi.getHolidays(payload.years).then((holidays: string[]) => {
                ctx.commit("setHolidays", holidays);
                return holidays;
            });
        },
        getMembershipTypes(ctx) {            
            return ServerApi.loadMembershipTypes().then((membershipTypes: IMembershipTypeViewModel[]) => {
                ctx.commit('setMembershipTypes', membershipTypes);
                return membershipTypes;
            });
        },        
        setSelectedServiceProducts(ctx, payload: { selectedServiceProducts: string[] }) {
            ctx.state.selectedServiceProducts = payload.selectedServiceProducts;
        },
        setloadingNewPhase(ctx, payload: { loadingNewPhase: boolean }) {
            ctx.commit("setloadingNewPhase", payload.loadingNewPhase);
        },
        isAuthenticated(ctx, payload: { isAuthenticated: boolean }) {
            ctx.commit("isAuthenticated", payload.isAuthenticated);
        },
        updateExtraFeature(ctx, payload: { name: string, amount: number, price: number }) {
            console.log("server update extrafeature: " + payload.name + "," + payload.amount + "," + payload.price);
            return ServerApi.updateExtraFeature(payload.name, payload.amount, payload.price)
                .then((result) => {
                    console.log("server updated");
                    ctx.dispatch("refreshContract");
                });
        },
        removeAndUpdateExtraFeature(ctx, payload: { originalname: string, name: string, amount: number, price: number }) {
            console.log("server update extrafeature: " + payload.name + "," + payload.amount + "," + payload.price);
            return ServerApi.removeAndUpdateExtraFeature(payload.originalname, payload.name, payload.amount, payload.price)
                .then((result) => {
                    return ServerApi.updateExtraFeature(payload.name, payload.amount, payload.price).then((result) => {
                        console.log("server updated");
                        ctx.dispatch("refreshContract");
                    });
                });
        },
        setOfferProduct(ctx, payload: { selectedProduct: string }) {            
            let index = ctx.state.offerProducts.indexOf(payload.selectedProduct);
            if (index == -1) {
                ctx.state.offerProducts.push(payload.selectedProduct);
                console.log("set selected offer product: " + payload.selectedProduct);
            }
            else {
                ctx.state.offerProducts.splice(index, 1);
                console.log("remove selected offer product: " + payload.selectedProduct);
            }
            return ServerApi.setOfferProducts(ctx.state.offerProducts)
                .then(() => {
                    console.log("offer product list updated");
                });
        }
    }
}

// With IE 9, arrays received from SignalR might actuallty be of type object (and not Array).
// That's why we cant use Array.find, but need to implement our own.
function find(obj, cond: (item) => boolean) {
    let count = obj.length;
    for (let i = 0; i < count; ++i) {
        let item = obj[i];
        if (cond(item))
            return item;
    }
    return null;
}

export default new Vuex.Store(store);